import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext} from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const SettingScreenButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { setIsModalOpen, reloadUserScreens } = rootStore.screensStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = async () => {
    await reloadUserScreens();
    setIsModalOpen(true);
  };

  return (
    <>
      <Button
        id="select"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          `${theme!.toolbarIconColor}`
        )}
        color=""
        onClick={async () => await handleClick()}
        style={{ position: "relative" }}
      >
        {/* <i className="fas fa-search-plus iconToolbarButton"></i> */}
        <i className="fas fa-cog iconToolbarButton"></i>
        {/* <i className="fas fa-sort-down"></i> */}
        <h6 className="textToolbarButton mb-0">
          {t("toolbar_screens_settings_button")}
        </h6>
      </Button>
    </>
  );
};

export default observer(SettingScreenButton);
